<div class="grid">
  <div class="col-12 wa-container">
    <!-- Top row: cuenta + switch -->
    <div class="estado-top-row" *ngIf="whatsappConnected">
      <div class="estado-account-card">
        <div class="wa-avatar"><i class="pi pi-whatsapp"></i></div>
        <div class="estado-account-card__info">
          <span class="estado-account-card__name">{{ readonlyPhoneDisplay }}</span>
        </div>
      </div>

      <div class="estado-dm-card">
        <div class="estado-dm-card__top">
          <div>
            <div class="cs-label-with-info">
              <span class="estado-dm-card__title">Activar chatbot en este canal</span>
              <i
                class="pi pi-info-circle cs-info-icon"
                pTooltip="Cuando esté desactivado, el número seguirá conectado pero el chatbot dejará de responder automáticamente."
                tooltipPosition="top"
              ></i>
            </div>
            <span class="estado-dm-card__desc"
              >El chatbot responde automáticamente los mensajes que recibe este número de
              WhatsApp.</span
            >
          </div>
          <p-inputSwitch
            [ngModel]="is_enabled"
            [disabled]="isDisconnectedByMeta"
            (onChange)="switchChanged($event)"
            [pTooltip]="
              isDisconnectedByMeta
                ? 'Tu cliente desconectó su WhatsApp Business de Globot. Reconéctalo para poder activarlo de nuevo.'
                : ''
            "
            tooltipPosition="top"
          ></p-inputSwitch>
        </div>
      </div>
    </div>

    <!-- Status banner -->
    <div
      class="estado-status-banner"
      *ngIf="whatsappConnected"
      [class.estado-status-banner--active]="is_enabled && !isDisconnectedByMeta"
      [class.estado-status-banner--inactive]="!is_enabled && !isDisconnectedByMeta"
      [class.estado-status-banner--disconnected]="isDisconnectedByMeta"
    >
      <div class="estado-status-banner__left">
        <div
          class="estado-status-dot"
          [class.estado-status-dot--active]="is_enabled && !isDisconnectedByMeta"
          [class.estado-status-dot--inactive]="!is_enabled && !isDisconnectedByMeta"
          [class.estado-status-dot--disconnected]="isDisconnectedByMeta"
        >
          <i
            [class]="
              isDisconnectedByMeta
                ? 'pi pi-exclamation-triangle'
                : is_enabled
                ? 'pi pi-check-circle'
                : 'pi pi-times-circle'
            "
          ></i>
        </div>
        <div>
          <span class="estado-status-title">
            {{
              isDisconnectedByMeta
                ? 'Se desconectó tu WhatsApp Business desde su celular. Reconéctala para seguir recibiendo mensajes.'
                : is_enabled
                ? 'Canal conectado y activo'
                : 'Canal conectado, respuestas pausadas'
            }}
          </span>
          <span class="estado-status-sub" *ngIf="!isDisconnectedByMeta">
            {{ readonlyPhoneDisplay }}
          </span>
        </div>
      </div>
      <div class="estado-status-banner__actions">
        <globot-button
          *ngIf="isDisconnectedByMeta"
          text="Reconectar"
          styleClass="whatsapp"
          icon="pi pi-whatsapp"
          iconPosition="left"
          width="w-100"
          [loading]="loading"
          (clickEvent)="connectWithMeta()"
        ></globot-button>
        <button
          *ngIf="!isDisconnectedByMeta"
          pButton
          pRipple
          type="button"
          class="p-button-outlined p-button-danger p-button-sm"
          icon="pi pi-times"
          label="Desconectar"
          [loading]="loading"
          (click)="showDeleteDialog(true)"
        ></button>
      </div>
    </div>

    <p *ngIf="embeddedConnected && !embeddedSignupEnabled" style="margin-bottom: 1rem">
      Este chatbot está conectado a WhatsApp vía Meta. El token se gestiona en el workspace; aquí
      solo puedes activar o desactivar el canal.
    </p>

    <!-- Sin conectar: hero + features, igual que Instagram -->
    <div class="estado-connect-layout" *ngIf="waStateReady && !whatsappConnected">
      <div class="estado-hero-card">
        <div class="estado-hero-banner"></div>
        <div class="estado-hero-body">
          <ng-container *ngIf="showMetaConnect">
            <div>
              <h2 class="estado-hero-title">Conecta tu número de WhatsApp</h2>
              <p class="estado-hero-sub">
                Vincula un número de teléfono (nuevo o existente) para que el chatbot pueda
                responder mensajes de WhatsApp automáticamente.
              </p>
            </div>
            <ol class="estado-steps">
              <li class="estado-step">
                <div class="estado-step__dot">1</div>
                <div class="estado-step__text">
                  <span class="estado-step__title">Un número de teléfono</span>
                  <span class="estado-step__desc"
                    >Puede ser un número nuevo o uno que ya uses en WhatsApp Business.</span
                  >
                </div>
              </li>
              <li class="estado-step">
                <div class="estado-step__dot">2</div>
                <div class="estado-step__text">
                  <span class="estado-step__title">Verifica tu número</span>
                  <span class="estado-step__desc"
                    >Meta te enviará un código por SMS o llamada para confirmar que el número es
                    tuyo.</span
                  >
                </div>
              </li>
              <li class="estado-step">
                <div class="estado-step__dot">3</div>
                <div class="estado-step__text">
                  <span class="estado-step__title">Autoriza el acceso</span>
                  <span class="estado-step__desc"
                    >Haz clic en Conectar y autoriza el acceso a tu número de WhatsApp.</span
                  >
                </div>
              </li>
            </ol>
            <div class="estado-btn-stack">
              <globot-button
                text="Conectar WhatsApp con Meta"
                styleClass="whatsapp"
                icon="pi pi-whatsapp"
                iconPosition="left"
                width="w-100"
                [loading]="loading"
                (clickEvent)="connectWithMeta()"
              ></globot-button>
            </div>
          </ng-container>

          <ng-container *ngIf="showManualEditableForm">
            <div>
              <h2 class="estado-hero-title">Conecta tu número de WhatsApp</h2>
              <p class="estado-hero-sub">
                Sigue el paso a paso del tutorial y completa tu número de teléfono para vincularlo
                manualmente.
              </p>
            </div>
            <ol class="estado-steps">
              <li class="estado-step">
                <div class="estado-step__dot">1</div>
                <div class="estado-step__text">
                  <span class="estado-step__title">Sigue el tutorial de integración</span>
                  <span class="estado-step__desc">
                    <a href="https://globot.ai/tutoriales/whatsapp" target="_blank"
                      >¿Cómo integrar mi chatbot en WhatsApp?</a
                    >
                  </span>
                </div>
              </li>
              <li class="estado-step">
                <div class="estado-step__dot">2</div>
                <div class="estado-step__text">
                  <span class="estado-step__title">Completa tu número de teléfono</span>
                  <span class="estado-step__desc"
                    >Ingresa el número que usará el chatbot para responder por WhatsApp.</span
                  >
                </div>
              </li>
            </ol>
            <form [formGroup]="whatsappBot" class="bodyForm">
              <div class="inputs-form">
                <div class="flex-auto">
                  <label for="phoneNumber"> Número de teléfono </label>
                  <input
                    pInputText
                    formControlName="phoneNumber"
                    pKeyFilter="int"
                    id="phoneNumber"
                    placeholder="Ej: 56 91234567"
                  />
                </div>
                <div class="flex-auto">
                  <globot-button
                    text="Guardar"
                    styleClass="raised"
                    [loading]="loading"
                    (clickEvent)="onSubmit()"
                    width="w-100"
                    iconPosition="left"
                  >
                  </globot-button>
                </div>
              </div>
            </form>
          </ng-container>
        </div>
      </div>

      <div class="estado-features">
        <span class="estado-features__label">Una vez conectado podrás</span>
        <div class="estado-feature-card" *ngFor="let item of benefitItems">
          <div class="estado-feature-card__icon"><i [class]="item.icon"></i></div>
          <div class="estado-feature-card__text">
            <span class="estado-feature-card__title">{{ item.title }}</span>
            <span class="estado-feature-card__desc">{{ item.subtitle }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Números que escribieron este mes -->
    <div class="estado-comments-card" *ngIf="whatsappConnected" style="align-self: stretch">
      <div class="estado-comments-header">
        <div style="display: flex; align-items: center; gap: 8px">
          <span class="wa-contacts-icon"><i class="pi pi-phone"></i></span>
          <span class="estado-comments-title">Números que escribieron este mes</span>
        </div>
        <span class="wa-contacts-count"
          >{{ totalContacts }} número{{ totalContacts === 1 ? '' : 's' }}</span
        >
      </div>

      <div *ngIf="loadingContacts" class="estado-comments-empty">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando números...</span>
      </div>

      <div *ngIf="!loadingContacts && recentContacts.length === 0" class="estado-comments-empty">
        <i class="pi pi-phone"></i>
        <span>Aún no hay números que hayan escrito este mes.</span>
      </div>

      <div
        *ngFor="let contact of recentContacts; trackBy: trackByContactPhone; let last = last"
        class="estado-comment-row"
        [class.estado-comment-row--last]="last && !hasMoreContacts"
      >
        <div class="estado-comment-content">
          <div class="estado-comment-meta">
            <span class="estado-comment-user">{{ contact.name || contact.phone }}</span>
            <span class="estado-comment-time" *ngIf="contact.last_message_at">{{
              timeAgo(contact.last_message_at)
            }}</span>
          </div>
          <p *ngIf="contact.name" class="estado-comment-text">{{ contact.phone }}</p>
        </div>
      </div>

      <div *ngIf="hasMoreContacts && !loadingContacts" class="estado-comments-footer">
        <button
          pButton
          pRipple
          type="button"
          class="p-button-text p-button-sm"
          label="Ver todos →"
          (click)="openContactsDialog()"
        ></button>
      </div>
    </div>
  </div>

  <div class="attention-schedule-wrapper" *ngIf="whatsappConnected && attentionScheduleConfig">
    <globot-attention-schedule-config
      [config]="attentionScheduleConfig"
      [saving]="savingAttentionSchedule"
      (save)="saveAttentionSchedule($event)"
    ></globot-attention-schedule-config>
  </div>
</div>

<p-dialog [(visible)]="deleteDialogVisible" [modal]="true" [closable]="false">
  <div class="content-dialog-delete">
    <h1>Desconectar de WhatsApp</h1>
    <br />
    <div class="description-content">
      <i class="pi pi-exclamation-triangle" style="color: #eab308"></i>
      <div class="description">
        <p>
          ¿Deseas desconectar tu asistente de WhatsApp? La configuración de este canal en Globot se
          eliminará y tendrás que conectar de nuevo para volver a usarlo.
        </p>
      </div>
    </div>
    <br />
    <div style="display: flex; flex-direction: row; justify-content: flex-end">
      <button
        pButton
        pRipple
        type="button"
        label="Cancelar"
        class="p-button-text"
        (click)="closeDialogDelete()"
      ></button>
      <button
        pButton
        type="button"
        label="Sí, desconectar"
        (click)="deleteWhatsappConnection()"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="contactsDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  header="Números que escribieron este mes"
  styleClass="comments-history-dialog"
  [style]="{ width: '480px', maxWidth: '95vw' }"
>
  <div class="chd-body">
    <div *ngIf="dialogLoading" class="chd-loading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Cargando...</span>
    </div>

    <div *ngIf="!dialogLoading && dialogContacts.length === 0" class="chd-empty">
      <i class="pi pi-phone"></i>
      <span>Sin números en esta página.</span>
    </div>

    <div
      *ngFor="let contact of dialogContacts; trackBy: trackByContactPhone; let last = last"
      class="chd-comment-row"
      [class.chd-comment-row--last]="last"
    >
      <div class="chd-content">
        <div class="chd-meta">
          <span class="chd-user">{{ contact.name || contact.phone }}</span>
          <span class="chd-time" *ngIf="contact.last_message_at">{{
            timeAgo(contact.last_message_at)
          }}</span>
        </div>
        <p *ngIf="contact.name" class="chd-text">{{ contact.phone }}</p>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="chd-pagination">
      <span class="chd-pagination__info">
        {{ dialogTotal }} número{{ dialogTotal !== 1 ? 's' : '' }} en total
      </span>
      <div class="chd-pagination__controls">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-outlined p-button-sm"
          aria-label="Página anterior"
          [disabled]="dialogPage <= 1 || dialogLoading"
          (click)="loadContactsDialogPage(dialogPage - 1)"
        ></button>
        <span class="chd-pagination__page">{{ dialogPage }} / {{ dialogTotalPages }}</span>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-outlined p-button-sm"
          aria-label="Página siguiente"
          [disabled]="dialogPage >= dialogTotalPages || dialogLoading"
          (click)="loadContactsDialogPage(dialogPage + 1)"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
